<script setup>
import { computed, onMounted, ref } from 'vue'
import { socialShareImage, usePageHead } from '@composables/use-page-head'
import { useRoute } from 'vue-router'
import DataLayer from '@services/data-layer/index'
import ShowScheduleMixBlock from '@components/show-schedule-mix-block'

const PLACEHOLDER_ROWS = 10
const HISTORY_LIMIT = 60

// channel.vue passes this down as `:channel="resource"`.
const props = defineProps({
    channel: {
        type: Object,
        default: () => ({}),
    },
    nowPlaying: {
        type: Object,
        default: () => ({}),
    },
})

const route = useRoute()

const stationsPlaylist = ref(
    Array.from(Array(PLACEHOLDER_ROWS), (_row, id) => ({
        id,
        mixes: {
            id,
            // Router 4 throws `Missing required param` on an empty string, and a
            // dead skeleton link takes the whole page down with it.
            show: {
                id,
                title: '',
                url: '',
                type: '',
                image: {},
                genre: [],
                artist_id: {},
                artist: {},
            },
        },
    }))
)

onMounted(() => {
    const yesterday = new Date()
    yesterday.setDate(yesterday.getDate() - 1)

    DataLayer.stationsPlaylists
        .get(route.params.channelId, yesterday, HISTORY_LIMIT, 0)
        .then(response => {
            const now = new Date()
            stationsPlaylist.value = response.body
                .filter(record => new Date(record.scheduled_start_time) < now)
                .reverse()
        })
})

usePageHead(computed(() => {
    const channelTitle = props.channel.title || 'Channel'

    return {
        title: `History — ${channelTitle}`,
        description: `Recently played mixes on ${channelTitle}.`,
        image: socialShareImage(),
    }
}))
</script>

<template>
    <BaseContent>
        <BaseSection
            title="History"
            padded
        >
            <p class="timezone-note">
                All times shown in your local timezone
            </p>
            <ShowScheduleMixBlock :resources="stationsPlaylist" />
        </BaseSection>
    </BaseContent>
</template>

<style lang="scss" scoped>
@import '@design';

.timezone-note {
    @extend %contentSubtitleS;

    margin: 0 0 $s-m;
    color: $c-text-disabled;
}
</style>
